import { render, staticRenderFns } from "./DesignInsight.vue?vue&type=template&id=5396ccfc&scoped=true"
import script from "./DesignInsight.vue?vue&type=script&lang=js"
export * from "./DesignInsight.vue?vue&type=script&lang=js"
import style0 from "./DesignInsight.vue?vue&type=style&index=0&id=5396ccfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396ccfc",
  null
  
)

export default component.exports